// extracted by mini-css-extract-plugin
export default {"filter":"UserTicketsTable_filter__Za8Ti"};